import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { Container, Row, Col } from 'react-grid-system';
import { getLinkTag } from '../../utils';
import styles from './footer.module.scss';

const buildLink = (item, className, hasKey = false) => {
  const linkInformation = getLinkTag(item.pathname);
  const Tag = linkInformation.tag;
  const { tagProps } = linkInformation;
  if (hasKey) {
    tagProps.key = item.id;
  }
  return (<Tag {...tagProps} className={className}>{item.label}</Tag>);
};

function Footer() {
  return (
    <StaticQuery
      query={footerQuery}
      render={(data) => {
        const {
          logoTextColumn,
          navColumn1,
          navColumn2,
          navColumn3,
          note,
          secondaryFooterLinks,
          textColumn,
        } = data.contentfulFooter;
        const defaultSize = {
          xs: 6, md: 3, lg: 2.4, lgPush: 0,
        };
        const primarySize = {
          xs: 6, md: 6, lg: 2.4, lgPush: 2.4,
        };
        const secondarySize = {
          xs: 6, md: 6, lg: 2.4, lgPush: 4.8,
        };
        let colSize = defaultSize;
        let colTextSize = defaultSize;

        if (navColumn2 === null || navColumn3 === null) {
          colSize = primarySize;
          colTextSize = {
            xs: 12, md: 6, lg: 2.4, lgPush: 2.4,
          };
        }

        if (navColumn2 === null && navColumn3 === null) {
          colSize = secondarySize;
          colTextSize = secondarySize;
        }

        return (
          <footer className={styles.footer}>
            <Container>
              <div className={styles.footerPrimary}>
                <Row>
                  <Col xs={12} md={12} lg={2.4} align-self="center">
                    {logoTextColumn && (
                      <div
                        className={styles.textColumn}
                        dangerouslySetInnerHTML={{
                          __html: logoTextColumn.childMarkdownRemark.html,
                        }}
                      />
                    )}
                  </Col>
                  {navColumn1 && (
                    <Col xs={colSize.xs} md={colSize.md} lg={colSize.lg} push={{ lg: colSize.lgPush }}>
                      <ul className={styles.list}>
                        {navColumn1.map(item => (
                          <li key={item.id} className={styles.listItem}>
                            {buildLink(item, styles.link)}
                          </li>
                        ))}
                      </ul>
                    </Col>
                  )}
                  {navColumn2 && (
                    <Col xs={colSize.xs} md={colSize.md} lg={colSize.lg} push={{ lg: colSize.lgPush }}>
                      <ul className={styles.list}>
                        {navColumn2.map(item => (
                          <li key={item.id} className={styles.listItem}>
                            {buildLink(item, styles.link)}
                          </li>
                        ))}
                      </ul>
                    </Col>
                  )}
                  {navColumn3 && (
                    <Col xs={colSize.xs} md={colSize.md} lg={colSize.lg} push={{ lg: colSize.lgPush }}>
                      <ul className={styles.list}>
                        {navColumn3.map(item => (
                          <li key={item.id} className={styles.listItem}>
                            {buildLink(item, styles.link)}
                          </li>
                        ))}
                      </ul>
                    </Col>
                  )}
                  {textColumn && (
                    <Col xs={colTextSize.xs} md={colTextSize.md} lg={colTextSize.lg} push={{ lg: colTextSize.lgPush }}>
                      <div
                        className={styles.textColumn}
                        dangerouslySetInnerHTML={{
                          __html: textColumn.childMarkdownRemark.html,
                        }}
                      />
                    </Col>
                  )}
                  {note && (
                    <Col xs={12}>
                      <div className={styles.disclaimer}>{note}</div>
                    </Col>
                  )}
                </Row>
              </div>

              {secondaryFooterLinks && (
                <div className={styles.footerSecondary}>
                  <Row>
                    <Col>
                      {secondaryFooterLinks.map(item => buildLink(item, styles.linkSecondary, true))}
                    </Col>
                  </Row>
                </div>
              )}
            </Container>
          </footer>
        );
      }}
    />
  );
}

export default Footer;

const footerQuery = graphql`
    query FooterQuery {
        contentfulFooter(contentfulid: {eq: "Footer"}) {
            id,
            logoTextColumn {
              childMarkdownRemark {
                  html
              }
            },
            navColumn1 {
                id,
                label,
                pathname
            },
            navColumn2 {
                id,
                label,
                pathname
            },
            navColumn3 {
                id,
                label,
                pathname
            },
            textColumn {
                childMarkdownRemark {
                    html
                }
            },
            note,
            secondaryFooterLinks {
                id,
                label,
                pathname
            }
        }
    }
`;
